import React, { useEffect, useRef } from "react";
import Map from "./Map";
import { useMapContext } from "./MapContext";
import Marker from "./Marker";
import Search from "./Search";
import SideBar from "./SideBar";
import Spinner from "./Spinner";
import { MarkerClusterer } from "@react-google-maps/api";

const center = {
  lat: 51.1688679,
  lng: 10.483958,
};

export default function Providers() {
  const { providerMarkers, providers, setOpen, isLoaded, baseUrl } =
    useMapContext();

  const clustererRef = useRef(null);

  const clusterOptions = {
    // imagePath: `${baseUrl}/webcomponents/src/direflow-components/fvk-provider-map/icons/soundbowlGold`, // Basispfad zu Ihren Bildern
    // imageExtension: "svg", // Erweiterung Ihrer Bilder
    // imageSizes: [30, 30, 30, 30, 30], // Größen Ihrer Bilder
    // calculator: function (markers, numStyles) {
    //   // Optional: Benutzerdefinierte Berechnung, welche Stilnummer basierend auf der Anzahl der Marker im Cluster verwendet werden soll
    //   // Rückgabewert sollte ein Objekt sein {text: '...', index: ...}
    // },
    styles: [
      {
        textColor: "white",
        url: `${baseUrl}/webcomponents/src/direflow-components/fvk-provider-map/icons/circleGold.svg`,
        height: 40,
        width: 40,
        textSize: 14,
      },
    ],
  };

  const visibleLength = providerMarkers?.filter(
    (marker) => marker?.visible
  ).length;
  useEffect(() => {
    if (providerMarkers.length > 0 && clustererRef?.current) {
      clustererRef?.current?.repaint();
    }
  }, [visibleLength]);

  return (
    <div style={{ width: "100%", height: "100%", display: "flex" }}>
      <div
        style={{
          width: "100%",
          height: "100%",
          position: "absolute",
          background: "#000000cc",
          top: 0,
          left: 0,
          zIndex: 10000,
          opacity: providers?.current?.length > 0 ? "0" : "1",
          display: "flex",
          pointerEvents: providers?.current?.length > 0 ? "none" : "auto",
          transition: "opacity 0.3s",
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",
          gap: 15,
          color: "white",
        }}
      >
        <Spinner />
        <div>Lade Adressen</div>
      </div>
      <SideBar />
      <Map center={center}>
        <MarkerClusterer
          options={clusterOptions}
          // onClusteringBegin={() => clustererRef?.current?.clearMarkers()}
          onUnmount={(clusterer) => clusterer.clearMarkers()}
          onLoad={(clusterer) => (clustererRef.current = clusterer)}
        >
          {(clusterer) => {
            // clusterer.clearMarkers();
            return providerMarkers?.map((providerMarker) => (
              <Marker
                key={providerMarker?.key}
                setOpen={setOpen}
                providerMarker={providerMarker}
                clusterer={clusterer}
              />
            ));
          }}
        </MarkerClusterer>
      </Map>
      {isLoaded && (
        <div
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            width: 500,
            maxWidth: "calc(100% - 20px)",
          }}
        >
          <Search />
        </div>
      )}
    </div>
  );
}
